export const searchActionsTypes = {
  SET_PROPERTIES: 'SET_PROPERTIES'
};

export const setProperties = (properties: Array<any>) => {
  return {
    type: searchActionsTypes.SET_PROPERTIES,
    data: properties
  };
};
